import { Button, Icon } from '@design-system';
import { useTranslation } from 'next-i18next';

export const IdentityVerificationCard = () => {
  const { t } = useTranslation('checkout');

  return (
    <div className="flex flex-col gap-4 rounded-sm bg-neutral-1 p-4">
      <div className="flex gap-2">
        <Icon className="shrink-0 text-neutral-4" name="ic_error" size="sm" />

        <div className="flex flex-col gap-1">
          <p className="font-bold">{t('success.identityVerification.title')}</p>
          <p className="text-pretty">
            {t('success.identityVerification.body')}
          </p>
        </div>
      </div>

      <Button
        as="a"
        fullWidth
        href="/aml"
        icon="ic_arrow_top_right"
        label={t('success.identityVerification.cta')}
        variant="primary"
      />
    </div>
  );
};
